import { render, staticRenderFns } from "./paymentSandboxManageList.vue?vue&type=template&id=68e2530a&scoped=true"
import script from "./paymentSandboxManageList.vue?vue&type=script&lang=js"
export * from "./paymentSandboxManageList.vue?vue&type=script&lang=js"
import style0 from "./paymentSandboxManageList.vue?vue&type=style&index=0&id=68e2530a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e2530a",
  null
  
)

export default component.exports